<!--
PlasticBadge
塑料底徽章
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="徽章 > 塑料底" name="塑料底徽章">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in plasticBadge"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="plasticBadgeFormActive">
              <CircularPlasticBadge v-if="plasticBadge[0].status"/>
              <SquarePlasticBadge v-if="plasticBadge[1].status"/>
              <HeartshapedPlasticBadge v-if="plasticBadge[2].status"/>
              <RectanglePlasticBadge v-if="plasticBadge[3].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>

import CircularPlasticBadge from "./PlasticBadge/CircularPlasticBadge.vue";
import SquarePlasticBadge from "./PlasticBadge/SquarePlasticBadge.vue";
import HeartshapedPlasticBadge from "./PlasticBadge/HeartshapedPlasticBadge.vue";
import RectanglePlasticBadge from "./PlasticBadge/RectanglePlasticBadge.vue";
export default {
  name: "PlasticBadge",
  methods: {},
  components: {
    CircularPlasticBadge,
    SquarePlasticBadge,
    HeartshapedPlasticBadge,
    RectanglePlasticBadge
  },
  data() {
    return {
      forcollapse: ['圆形塑料底','方形塑料底','心形塑料底','长方形塑料底'],
      plasticBadge: [
        { id: "CircularPlasticBadge", name: "圆形", status: false },
        { id: "SquarePlasticBadge", name: "方形", status: false },
        { id: "HeartshapedPlasticBadge", name: "心形", status: false },
        { id: "RectanglePlasticBadge", name: "长方形", status: false }
      ],
      plasticBadgeFormActive: []
    };
  }
};
</script>
<style scoped>
</style>